// Node Modules
import React, { Component } from "react";

// Global Components
import ColorSelector from "components/colorSelector/colorSelector";

// Local CSS
import "./colorSelector.css";

class ProductColorSelector extends Component {
  render() {
    return (
      <div className="productColorSelector">
        <div className="colorSelectorGroup">
          {this.props.colors.values.map((color, index) => {
            if (this.props.color === color.value) {
              return (
                <ColorSelector
                  color={color.value}
                  active
                  key={index}
                  onClickHandler={() => {
                    this.props.selectOption("Color", color.value);
                  }}
                />
              );
            }
            return (
              <ColorSelector
                color={color.value}
                key={index}
                onClickHandler={() => {
                  this.props.selectOption("Color", color.value);
                }}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default ProductColorSelector;
